import React, { useState } from 'react';
import { A } from 'hookrouter';
import moment from 'moment';
import OnHoverTooltip from '../tables/shared/OnHoverTooltip';
import { useTranslation } from 'react-i18next';
import { EMPLOYEE_DETAILS_HOURS_LABEL, EMPLOYEE_DETAILS_HOURS_DESC, EMPLOYEE_DETAILS_OFFICE_LABEL, EMPLOYEE_DETAILS_COMPANY_LABEL, EMPLOYEE_DETAILS_START_DATE_LABEL, EMPLOYEE_DETAILS_END_DATE_LABEL, EMPLOYEE_DETAILS_SKILLS_LABEL, EMPLOYEE_DETAILS_BIRTH_DATE_LABEL, EMPLOYEE_DETAILS_ADRESS_LABEL, EMPLOYEE_DETAILS_EMAIL_LABEL, EMPLOYEE_DETAILS_PHONE_NUMBER_LABEL,EMPLOYEE_DETAILS_CAR_LABEL } from '../../i18n/keyConstants';



const EmployeeInfo = (props) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { t } = useTranslation(['employeeDetails']);


    const scrollTop = () => {
        window.scrollTo({ top: 0, left: 0 });
    };

    const { subordinates, bosses, employee, setEmployeeId } = props;

    return (
        <div className='container margin-top-15px employee-info'>
            <div className='row'>
                <div className='col-lg-3 col-6'>
                    <label>{t(EMPLOYEE_DETAILS_OFFICE_LABEL)}</label>
                    <p>{employee.office}</p>
                    <label>{t(EMPLOYEE_DETAILS_COMPANY_LABEL)}</label>
                    <p>{employee.company}</p>
                    {employee.startDate && (
                        <>
                            <label>{t(EMPLOYEE_DETAILS_START_DATE_LABEL)}</label> <p>{employee.startDate.substring(0, 10)}</p>
                        </>
                    )}

                    {employee.endDate && moment(employee.endDate) < moment() ? (
                        <>
                            <label>{t(EMPLOYEE_DETAILS_END_DATE_LABEL)}</label>
                            <p>{employee.endDate.substring(0, 10)}</p>
                        </>
                    ) : null}
                    {employee.skills && (
                        <>
                            <label>{t(EMPLOYEE_DETAILS_SKILLS_LABEL)}</label>
                            <p>{employee.skills}</p>
                        </>
                    )}
                </div>
                <div className='col-lg-3 col-6'>
                    <label>{t(EMPLOYEE_DETAILS_BIRTH_DATE_LABEL)}</label>
                    <p>{employee.birthDate}</p>
                    <OnHoverTooltip
                        dataFor='hours-label'
                        labelClassNames=''
                        tooltipType='dark'>

                        <span>
                            {t(EMPLOYEE_DETAILS_HOURS_LABEL)}
                            <span className='oi oi-info c-steelblue padding-left-10px' />
                        </span>
                        <span>{t(EMPLOYEE_DETAILS_HOURS_DESC)}</span>

                    </OnHoverTooltip>
                    <p>{employee.hours}</p>

                    {employee.phone && (
                        <>
                            <label>{t(EMPLOYEE_DETAILS_PHONE_NUMBER_LABEL)}</label>
                            <p>
                                <a
                                    className='c-dim-gray'
                                    href={`tel:${employee.phone.replace(/[ -]/g, '')}`}
                                    target='_blank'
                                    rel='noopener noreferrer'>
                                    {employee.phone}
                                </a>
                            </p>
                        </>
                    )}
                    {employee.car && (
                        <>
                            <label>{t(EMPLOYEE_DETAILS_CAR_LABEL)}</label>
                            <p>{employee.car}</p>
                        </>
                    )}
                    {/*{employee.address && (*/}
                    {/*    <>*/}
                    {/*        <label>{t(EMPLOYEE_DETAILS_ADRESS_LABEL)}</label>*/}
                    {/*        {employee.address.split('\n').map((text, index) => {*/}
                    {/*            return (*/}
                    {/*                <p key={index} className={index === 0 ? 'margin-none' : ''}>*/}
                    {/*                    {text}*/}
                    {/*                </p>*/}
                    {/*            );*/}
                    {/*        })}*/}
                    {/*    </>*/}
                    {/*)}*/}
                    {employee.email && (
                        <>
                            <label>{t(EMPLOYEE_DETAILS_EMAIL_LABEL)}</label>
                            <p className='text-truncate'>
                                <a className='c-dim-gray' href={`mailto:${employee.email}`} target='_blank' rel='noopener noreferrer'>
                                    {employee.email}
                                </a>
                            </p>
                        </>
                    )}
                </div>
                <div className='col-lg-6'>
                    <div className='row'>
                        {bosses && employee.id.toUpperCase() !== 'PHN'
                            ? bosses.map((row, index) => {
                                  return (
                                      <div key={index} className='col-12'>
                                          <div>
                                              <A href={`/employee/${row.empId.toLowerCase()}/info`} className='card'>
                                                  <div
                                                      onClick={() => {
                                                          setEmployeeId(row.empId);
                                                          scrollTop();
                                                      }}
                                                      className='card-body padding-top-10px padding-bottom-10px padding-right-10px'>
                                                      {row.name}
                                                  </div>
                                              </A>
                                          </div>
                                          <p className='text-center margin-none'>
                                              <span className='oi oi-caret-bottom'></span>
                                          </p>
                                      </div>
                                  );
                              })
                            : null}

                        {subordinates.length !== 0 ? (
                            <div className='col-12'>
                                <div
                                    onClick={() => setIsCollapsed(!isCollapsed)}
                                    className='card bg-light-licorice c-white-smoke'
                                    data-toggle='collapse'
                                    data-target='#collapseOne'
                                    aria-expanded='true'
                                    aria-controls='collapseOne'>
                                    <div className='card-body padding-top-10px padding-bottom-10px card-active-profile d-flex justify-content-between'>
                                        {employee.name}
                                        <span className={isCollapsed ? 'oi oi-chevron-bottom' : 'oi oi-chevron-top'}></span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='col-12'>
                                <div className='card bg-light-licorice c-white-smoke'>
                                    <div className='card-body padding-top-10px padding-bottom-10px'>{employee.name}</div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div id='collapseOne' className='collapse show' role='button'>
                        {subordinates.length !== 0 ? (
                            <p className='margin-none text-center'>
                                <span className='oi oi-caret-bottom'></span>
                            </p>
                        ) : null}

                        <div className='row'>
                            {subordinates &&
                                subordinates.map((row, index) => {
                                    return (
                                        <div className='col-12 col-md-6 col-lg-12 col-xl-6' key={index}>
                                            <A
                                                href={`/employee/${row.id}/info`}
                                                className='card margin-bottom-5px'
                                                onClick={() => {
                                                    setEmployeeId(row.id);
                                                    scrollTop();
                                                }}>
                                                <div className='card-body padding-top-10px padding-bottom-10px text-truncate'>
                                                    {row.name}
                                                </div>
                                            </A>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeInfo;
